export const NACIN_PLACILA_UPDATED = 'NACINPLACILA_UPDATED';